import React from 'react'
import t from '../Language/language'
import * as languageSettings from '../Language/languageSettings'
import '../Header/Header.css'
import { Config } from '../../Config'
import MasqueradeHeader from '../Header/masqueradeHeader'
import Api from '../../Api'
import AuthenticationService from '../Security/AuthenticationService'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { CommonConstants } from '../../Constants'
import 'url-search-params-polyfill'
import NavigationServices from '../Common/NavigationServices'
import { checkAccess } from '../../actions/permissions'
import { setInviteResponseFromCloud, inviteResponseFromCloud } from "../../actions/headers";
import Modal from 'react-modal'
import { confirmAlert } from "react-confirm-alert";
const _ = require('underscore');

const ProductLogo = require('../../images/ProductLogo-1.png')
const AdminProductLogo = require('../../images/ProductLogo-2.png')
const HMELogo = require('../../images/HMELogo.png')
const CogWheel = require('../../images/Cog.png')
const Bell = require('../../images/bell.png')
const customStyles = {
  content : {
    position              : 'fixed',
    top                   : '70px',
    left                  : '68%',
    bottom                : 'auto',
    width                 : "450px",
    height                : '440px'
  }
};

/// Component design to handle complete Header like(logo, LoggedIn username, logout button, Main Menu and cog menu)
class HmeHeader extends React.Component {
  constructor (props) {
    super(props)
    this.authService = new AuthenticationService(Config.authBaseUrl)
    this.navigation = new NavigationServices()
    this.state = {
      language: languageSettings.getCurrentLanguage(),
      settingsDropdown: false,
      showSubMenu: true,
      contextUser: {
        User_EmailAddress: ''
      },
      loggedInUser: {},
      token: this.authService.getToken(),
      showInviteResponseModal: false,
      closeModal: false,
      invitor: null,
      InviteDetails: {},
      successMessage: null,
      errorMessage: null,
      inviteResponseErrorMessage: null,
      showBellInviteIcon: false
    };
    this.apiMediator = new Api()
    this.state.url = this.authService.getColdFusionAppUrl(this.authService.isAdmin())
    this.state.masquerade = this.authService.isMasquerade()
    this.setWrapperRef = this.setWrapperRef.bind(this)
    this.handleClickOutside = this.handleClickOutside.bind(this)
    this.state.isLogIn = (window.location.pathname === '/admin' || window.location.pathname === '/')
  }

  /// component lifecycle event to component mount Register mouse event
  componentDidMount () {
    if(this.authService.getPermission() && this.authService.getPermission().length > 0){
      if(this.authService.getProfile().IsAccountOwner === 1 || this.authService.getProfile().SL === 2 && checkAccess(CommonConstants.userPermissions.EditLeaderboard)){
        let companyUrl = Config.apiBaseUrl + CommonConstants.apiUrls.getCompany;
        if(this.authService.getCompanyUID()){
          this.getLatestInvite(this.authService.getCompanyUID(), false);
          console.log("Perm 1:");
        } else {
          this.apiMediator.getData(companyUrl, data => {
            this.authService.setCompanyUID(data.companyUId);
            this.getLatestInvite(data.companyUId, false);
            console.log("Perm 1 Company:");
          });
        }
      }
    } else {
      if(this.authService.isLoggedIn()){
        this.apiGetPermissions();
      }
    }
    this.setState(this.state);
    this.setUserContext() // to-do: remove this once its set @ cfm-app
    document.addEventListener('mousedown', this.handleClickOutside)
  }

  ///component lifecycle event to component Will receive the props from redux
  componentWillUnmount () {
    document.removeEventListener('mousedown', this.handleClickOutside)
  }

  apiGetPermissions () {
    console.time();
    if (!this.authService.isAdmin()) {
      let url = Config.apiBaseUrl + CommonConstants.apiUrls.getPermissions;
      if (this.authService.getUUID()) {
        url += '?uuid=' + this.authService.getUUID();
      }
      this.apiMediator.getData(url, data => {
        let newPermissions = _.pluck(data.data[0], 'Permission_Name');
        this.authService.setPermission(newPermissions);
        if(this.authService.getProfile().IsAccountOwner === 1 || this.authService.getProfile().SL === 2 && _.contains(newPermissions, CommonConstants.userPermissions.EditLeaderboard)){
          let companyUrl = Config.apiBaseUrl + CommonConstants.apiUrls.getCompany;
          if(this.authService.getCompanyUID()){
            this.getLatestInvite(this.authService.getCompanyUID(), false);
            console.log("Perm 2:");
          } else {
            this.apiMediator.getData(companyUrl, data => {
              this.authService.setCompanyUID(data.companyUId);
              this.getLatestInvite(data.companyUId, false);
              console.log("Perm 2 Company:");
            });
          }
        }
      });
    } 
    console.timeEnd();
  }

  getLatestInvite(CompanyUID, showModal) {
    let url = Config.apiBaseUrl + CommonConstants.apiUrls.getLatestInvite + "/" + CompanyUID;
    this.apiMediator.getData(url, res => {
      if(res.status){
        this.setState({InviteDetails: res.data});
        this.setState({invitor: res.invitor});
        this.setState({showBellInviteIcon: true});
        this.setState({showInviteResponseModal: showModal});
      } else {
        this.setState({showBellInviteIcon: false});
        this.setState({showInviteResponseModal: false});
      }
    });
  }

  /// setting user context from auhenticated token
  setUserContext () {
    this.state.contextUser = this.authService.getProfile()
    /// handling masquered condition to show logged in username
    let user = this.authService.isMasquerade() ? this.authService.getAdminProfile() : this.authService.getProfile()
    this.state.userName = user.name ? user.name : user.User_FirstName + ' ' + user.User_LastName
    if (!this.authService.isMasquerade() && this.authService.isLoggedIn() && this.state.userName === null) {
      let url = Config.apiBaseUrl + CommonConstants.apiUrls.getAccountInfo
      this.apiMediator.getData(url, data => {
        if (data && data.firstName && data.lastName) {
          this.state.userName = data.firstName + ' ' + data.lastName
          this.setState(this.state)
        }
      })
    }
    this.setState(this.state)
  }

  /// to render admin portal related menus
  renderAdminMenuItems () {
    const { language } = this.state
    if (this.authService.isAdmin() && this.authService.isLoggedIn() && !this.state.isLogIn) {
      return (
        <ul className='responsiveHeader'>
          {this.renderMenuItem('welcome', t[language].navbarWelcome)}
          {this.renderMenuItem('stores', t[language].stores)}
          {this.renderMenuItem('users', t[language].subNavbarUsers)}
          {this.renderMenuItem('systems', t[language].navbarSystems)}
          {this.renderMenuItem('accounts', t[language].navbarAccounts)}
          {this.renderMenuItem('distributors', t[language].navbarDistributers)}
        </ul>
      )
    } else {
      return ''
    }
  }

  /// To create header menu LI element by using NavigationService and
  /// AuthencationService for Seleted Menu
  renderMenuItem (menu, display, sub) {
    let active = (this.navigation.getSelectedMenu() === menu ? 'active_tab' : '')

    return (<li>
      <a className={'headerMenu ' + active} href={this.navigation.getUrl(menu)} >{display}</a>
    </li>)
  }

  /// to render client portal related menus
  renderClientMenuItems () {
    const { language } = this.state
    if (!this.authService.isAdmin() && this.authService.isLoggedIn() && !this.state.isLogIn) {
      return (
        <ul className='responsiveHeader'>
         {this.renderMenuItem('welcome', t[language].navbarWelcome, true)}
         {this.renderMenuItem('dashboard', t[language].navbarDashboard, true)}
         {this.renderMenuItem('reports', t[language].navbarReports, true)}
         {this.renderMenuItem('leaderBoards', t[language].Leaderboards, true)}
         {this.renderMenuItem('stores', t[language].navbarSettings, true)}
         {this.renderMenuItem('myAccount', t[language].navbarMyAccount, true)}
        </ul>
      )
    } else {
      return ''
    }
  }

  renderLogo () {
    if (this.authService.isAdmin()) {
      return (<img className='adminImage ' src={AdminProductLogo} aria-hidden='true' alt='admin logo' />)
    } else {
      return (<img src={ProductLogo} aria-hidden='true' alt='product logo' />)
    }
  }

  renderProfileHeader () {
    const { language, masquerade, userName } = this.state

    if (this.authService.isLoggedIn() && this.authService.isShowHeader(window.location.pathname)) {
      return (<span >
        <div>
          <div className='loggedInUser'>
            <a className='black_link headerLink loginInfo' href={this.navigation.getUrl('accounts')}><span> {t[language].headerLoggedInAs} </span> <span className='username'>{userName}</span></a>
          </div>
          <div>
            <span className={masquerade ? 'show' : 'hidden'}>
              <MasqueradeHeader />
            </span>
          </div>
        </div>
      </span>)
    } else {
      return (<span />)
    }
  }
  renderLogoutButton () {
    if (this.authService.isLoggedIn() && this.authService.isShowHeader(window.location.pathname)) {
      return (<button className='logout ' onClick={this.logout.bind(this)}> <span> {t[this.state.language].headerSignOut}</span></button>
      )
    } else {
      return ''
    }
  }
  renderMenu () {
    if (this.authService.isLoggedIn() && this.authService.isShowHeader(window.location.pathname)) {
      return (<div className='mainMenu menuBar '>
        {this.renderClientMenuItems()}
        {this.renderAdminMenuItems()}
      </div>)
    } else {
      return (<div />)
    }
  }
  renderSettings () {
    const { language } = this.state
    if (this.authService.isLoggedIn() && !this.authService.isAdmin() && this.authService.isShowHeader(window.location.pathname)) {
      return (<div >
        <div className='cogWheelSection'>
          <div className='dropdown open' ref={this.setWrapperRef}>
            <a href='javascript:void(0);' className='dropdown-toggle' onClick={this.toggle.bind(this)}><img className='cogWheel' src={CogWheel} aria-hidden='true' alt='settings icon' /></a>
            <ul className={'dropdown-menu dropdown-menu-right ' + (this.state.settingsDropdown ? 'show' : 'hide')}>
              <li><a href={this.navigation.getUrl('displaysettings')}>{t[language].navbarOptionSettings}</a></li>
              {this.authService.getProfile().SL === 2 && checkAccess(CommonConstants.userPermissions.EditLeaderboard) ? (<li><a href={this.navigation.getUrl('leaderboard')}>{t[language].customizeleaderboard}</a></li>) : '' }
              <li><a href={this.navigation.getUrl('help')}>{t[language].navbarOptionHelp}</a></li>
            </ul>
          </div>
        </div>
      </div>)
    } else {
      return (<div />)
    }
  }
  
  renderInviteResponseModal() {
    const { language } = this.state;
    let closeModal = () =>
      this.setState({
        showInviteResponseModal: false,
        showInviteError: false,
        showLoader: "hidden"
      });
    
      let sendInvite = async (status) => {
        this.props.setInviteResponseFromCloud({
          ParticipantID: this.state.InviteDetails.ParticipantID,
          // get status from state
          Status: status
        });
        await this.props.inviteResponseFromCloud(res => {
          if (res.status) {
            let self = this;
            this.state.successMessage = t[language][res.key];
            this.state.errorMessage = "";
            this.setState(this.state);
            if(status === "Accepted"){
              window.location.href = "/" + res.url;
            }
            this.setState({ showInviteResponseModal: false });
            this.setState({ invitor: null });
            this.setState({ InviteDetails: null });
            this.setState({ showLoader: "hidden" });
            if(this.authService.getCompanyUID()){
              this.getLatestInvite(this.authService.getCompanyUID(), false);
            }
          } else {
            // have a error msg tag to display error msg due to invite response
            this.state.showCommonLoader = false;
            this.setState(this.state);
            this.state.inviteResponseErrorMessage = t[language][res.key];
            let errors = [];
            errors.push(t[language][res.key]);
            this.setState(errors);
            this.state.successMessage = "";
            this.setState(this.state);
          }
        });   
      };

      // Method for removing leaderboards/groups.
      let sendReject = () => {
        const { language } = this.state;
        confirmAlert({
          title: t[language].declineInvitationHeader,
          message: t[language].declineInvitation,
          buttons: [
            {
              label: t[language].yes,
              onClick: () => {
                sendInvite("Denied")
              },
            },
            {
              label: t[language].no,
              onClick: () => {},
            },
          ],
        });
      }

      return ( 
      <Modal
        isOpen={this.state.showInviteResponseModal}
        onRequestClose={closeModal}
        style={customStyles}
        ariaHideApp={false}
        shouldCloseOnOverlayClick={true}
        onRequestClose={closeModal}
      >

      <div >
        <button type="button" className="popover-close close" arial-label="close" onClick={closeModal}>
          <span aria-hidden="true">&times;</span>
        </button>
        <div className="invite-modal">
            <p>{t[language].inviteHello} </p>
            <p>{this.state.invitor + t[language].inviteMessage1}</p>
            <p> </p>
            <p>
              <b>{t[language].inviteConsent}</b> {t[language].inviteMessage2}
              {this.state.invitor + t[language].inviteMessage3}
            </p>
            <p />
            <p>
              {t[language].inviteMessage4}
              <br/>{t[language].inviteMessage5}
            </p>
            <p />
            <div>
            <table cellSpacing="10" cellPadding="10" align="center">
              <tbody>
                <tr>
                  <td>
                    <button className={"btn btn-info "} onClick={sendInvite.bind(this, "Accepted")}>
                      <span> {t[language].inviteAcceptBtn1}<br/>{t[language].inviteAcceptBtn2}</span>
                    </button>
                  </td>
                  <td>
                  <button  className={"btn btn-danger invite-reject"} onClick={sendReject}>
                    <span> {t[language].inviteRejectBtn1}<br/>{t[language].inviteRejectBtn2} </span>
                  </button>
                  </td>
                </tr>
              </tbody>
              </table>
            </div>
            <p />
            <p>
              <b>{t[language].inviteOptout}</b>{t[language].inviteMessage6}
            </p>
        </div>
     
      </div>
      </Modal>
      );
  }

  render () {
    const { token, url, showBellInviteIcon } = this.state
    this.navigation.signoutIfNotLoggedIn()
    this.navigation.setSelectedMenu()
    return (
      <div >
        <header className={(!this.authService.isAdmin() ? 'reports-page-header' : 'reports-page-header-admin')}>
          <div> <a href={url + '?token=' + token}>
            {this.renderLogo()}
          </a></div>
          <div className='user-info-section'>

            <div className='logoutSectionIcons'>
              <img className={'logOutHMEIcon blue-link' + (showBellInviteIcon ? '' : ' hidden')} onClick={this.getLatestInvite.bind(this, this.authService.getCompanyUID(), true)} src={Bell} width="30" height="30" />

              {this.renderInviteResponseModal()}
            </div>

            {this.renderProfileHeader()}
            <div className='logoutSectionIcons'>
              {this.renderLogoutButton()}
              <img className={'logOutHMEIcon ' + (this.authService.isAdmin() ? 'hidden' : '')} src={HMELogo} aria-hidden='true' />
            </div>
          </div>
        </header>
        <nav className='reports-navigation-header'>
          <div id='Navbar' className='Navbar'>
            {this.renderMenu()}
          </div>
          {this.renderSettings()}
        </nav>
      </div>)
  }

  toggle () {
    this.state.settingsDropdown ? this.setState({ settingsDropdown: false }) : this.setState({ settingsDropdown: true })
  }

  logout () {
    let url = '/logout' // this.state.url + '?pg=Logout&token=' + this.state.token

    //ensure the session is terminated for both the http and https version of the site.
    if(window.location.protocol === 'http:')
    {
      //Switch to the https to ensure the https is logged out
      url = window.origin + url
      url = url.replace('http:', 'https:' )

      //clear the local storage for the http version
      window.localStorage.clear()

    }
    window.location.href = url
  }

  handleClickOutside (event) {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      this.setState({ settingsDropdown: false })
    }
  }
  setWrapperRef (node) {
    this.wrapperRef = node
  }
}

function mapStateToProps (state) {
  return {
    roles: state.roles
  }
}
function matchDispatchToProps (dispatch) {
  return bindActionCreators(
    {
      setInviteResponseFromCloud, 
      inviteResponseFromCloud
    }, dispatch
  )
}

export default connect(mapStateToProps, matchDispatchToProps)(HmeHeader)



// WEBPACK FOOTER //
// ./src/components/Header/HmeHeader.js